import { HOSPITOL_API_BASE_URL } from "@/core/config";
import { ISC_API_BASE_URL } from "@/core/inventory/config";

const BILLING_API_BASE = import.meta.env.VITE_BILLING_API_BASE_URL ?? "/api/billing";

export interface BackendHealthRow {
  id: string;
  label: string;
  healthUrl: string;
}

export const BACKEND_HEALTH_CHECKS: BackendHealthRow[] = [
  {
    id: "hospitol-api",
    label: "Hospitol API",
    healthUrl: `${HOSPITOL_API_BASE_URL}/health`,
  },
  {
    id: "isc-api",
    label: "Inventory API (ISC)",
    healthUrl: `${ISC_API_BASE_URL}/health`,
  },
  {
    id: "billing-api",
    label: "Billing API (Kanakku)",
    healthUrl: `${BILLING_API_BASE}/health`,
  },
];

export async function probeBackendHealth(
  healthUrl: string,
): Promise<{ reachable: boolean; detail: string }> {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    const response = await fetch(healthUrl, {
      method: "GET",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    });
    clearTimeout(timeout);
    if (!response.ok) {
      return { reachable: false, detail: `HTTP ${response.status}` };
    }
    const body = (await response.json()) as { status?: string; product?: string };
    const status = body.status ?? "ok";
    const product = body.product ? ` (${body.product})` : "";
    return { reachable: true, detail: `${status}${product}` };
  } catch (err) {
    const message = err instanceof Error ? err.message : "Erreur réseau";
    return { reachable: false, detail: message };
  }
}
